
import Swiper from 'swiper';
import { Keyboard, Navigation, Pagination, Controller, Autoplay, FreeMode, EffectFade } from 'swiper/modules';
/*
import FormContact from "@/vue/components/FormContactV2.vue";*/
import FormContact from "@/vue/components/FormContactShow.vue";



let optsSwiper = {
    // Optional parameters
    direction: 'horizontal',
    observer: true,
    observeParents: true,
    slidesPerView: 1,


    loop: true,

    // Enable lazy loading
    lazy: true,

    keyboard: {
        enabled: true,
    },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination2',
        clickable: true,
        dynamicBullets: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next2',
        prevEl: '.swiper-button-prev2',
    },


    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },

    // Touch settings optimized for mobile
    grabCursor: true,
    simulateTouch: true,
    allowTouchMove: true,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 5,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    cssMode: false,
    touchStartPreventDefault: false,
    touchStartForcePreventDefault: false,
    touchMoveStopPropagation: false,
    resistance: true,
    resistanceRatio: 0.85,

    // Event callbacks
    on: {
        slideChange: function() {
            // Update counter when slide changes (works for both swipe and arrow clicks)
            updatePhotoCounter(this);
        }
    },

    modules: [Navigation, Pagination, Keyboard, Controller, Autoplay, EffectFade]
};

let photos = [];
document.querySelectorAll('img.swiper-img').forEach(el => {
    let index = parseInt(el.getAttribute('data-index-img'));
    photos[index] = {
        index: parseInt(el.getAttribute('data-index-img')),
        src: el.src || el.getAttribute('data-src'),
        title: el.getAttribute('data-title'),
        alt: el.getAttribute('alt'),
    };
});

let avaliableMobilePhotos= $('#avaliableMobilePhotos').val();
console.log('avaliableMobilePhotos', avaliableMobilePhotos);

const getItemsMarkup = (data) => {
    return data.reduce((prev, curr) => {
        let caption = '';
        let alt = '';

        if (curr.title && curr.title.trim()) {
            caption = `
					<div class="fs-swiper-caption">
						${curr.title}
					</div>
				`;
        }

        if (curr.alt && curr.alt.trim()) {
            alt = curr.alt;
        }

        let lazyclass='';
        let  lazyattr='';
        if (curr.index > 0) {
            lazyclass='swiper-lazy';
            lazyattr='loading="lazy"';
        }
       /* <img class="fs-swiper-image ${lazyclass}" src="${curr.src}" alt="${alt}" ${lazyattr} onerror="onErrorImage(this)"/>
        ${caption}*/

        var originalUrl = curr.src;

// O valor que você quer injetar
        var valueToInject480 = "480x270-";
        var valueToInjectThumbs = "tn-";
        var valueToInject900 = "900x506-";

// Usando replace() com uma expressão regular para injetar o valor após a última barra


        //criar um if para verificar se é suposto existirem imagens mobile

        /*console.log('avaliableMobilePhotos5', avaliableMobilePhotos);*/
        if(avaliableMobilePhotos === 'false'){

            var newUrl480 = curr.src;
            var newUrlThumbs = curr.src;
            var newUrl900 = curr.src;
            /*console.log('test',newUrl900);*/
        }else{
            var newUrl480 = originalUrl.replace(/\/([^\/]*)$/, "/" + valueToInject480 + "$1");
            var originalUrl = curr.src;
            var newUrlThumbs = originalUrl.replace(/\/([^\/]*)$/, "/" + valueToInjectThumbs + "$1");
            var originalUrl = curr.src;
            var newUrl900 = originalUrl.replace(/\/([^\/]*)$/, "/" + valueToInject900 + "$1");
            /*console.log('testno',newUrl900);*/

        }

        return prev + `
				<div class="normal swiper-slide d-flex align-items-center pop-fullscreen-images bg-white justify-content-center align-items-center d-flex" data-index-photo="${curr.index}">

					<picture class="justify-content-center align-items-center d-flex">
					    <source media="(min-width: 900px)" srcset="${curr.src}">

                    <!-- For screens with a width of at least 800px -->
                        <source media="(min-width: 800px)" srcset="${newUrl900}">
                        <!-- For screens with a width of at least 480px -->
                        <source media="(min-width: 480px)" srcset="${newUrlThumbs}">
                        <source media="(min-width: 300px)" srcset="${newUrl480}">
                    <img class="fs-swiper-image ${lazyclass}" src="${curr.src}" alt="${alt}" ${lazyattr} onerror="onErrorImage(this)">
                    </picture>
					<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
				</div>
			`;
    }, '');
}

/**
 *
 * @returns {Promise<Swiper>}
 */
const getMainSwiper = async () => {
    let currentSwiper = document.querySelector('.swiper-main-container').swiper;

    if (currentSwiper) {
        return Promise.resolve(currentSwiper)
    }

    if (photos.length === 0) {
        const id = document.querySelector('#my-property-id').value;

        const {data} = await axios.get(route('api.properties.photos', id));
        if (data) {
            photos = data;
        }
    }

    optsSwiper.data = photos;

    let wrapper = document.querySelector('#main-swiper-wraper');
    wrapper.innerHTML = getItemsMarkup(photos);

    let currentOptions = {...optsSwiper};

    /*console.debug('currentOptions', currentOptions)
    console.log(currentOptions);*/

    let target = document.querySelector('.swiper-main-container');

    if(target){
        return Promise.resolve(new Swiper(target, currentOptions));
    }

    return Promise.resolve(null);
}
if(document.querySelector('.swiper-main-container')){
    console.log('im confused');
    getMainSwiper().then();
}


const getSwiperFullScrren = () => {
    let swiperEl = document.querySelector('.swiper-fullscreen');
    if (!swiperEl) return null;
    let currentSwiper = swiperEl.swiper;

    if (currentSwiper) {
        return currentSwiper
    }

    let wrapper = document.querySelector('#main-swiper-fullscreen');
    if (!wrapper) return null;
    wrapper.innerHTML = getItemsMarkup(photos);

    let currentOptions = {...optsSwiper};
    currentOptions.pagination.el = '.swiper-pagination1';
    currentOptions.navigation.nextEl = '.swiper-button-next1';
    currentOptions.navigation.prevEl = '.swiper-button-prev1';
    currentOptions.keyboard.onlyInViewport = false;
    currentOptions.pagination.enabled = false;

    // Update the slideChange callback for fullscreen swiper
    currentOptions.on = {
        slideChange: function() {
            updatePhotoCounter(this);
        }
    };

    return new Swiper('.swiper-fullscreen', currentOptions);
}

const fetchLinksForPagination = () => {
    const propertyIdEl = document.querySelector('#my-property-id');
    if (!propertyIdEl) return;
    const id = propertyIdEl.value;

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(String(prop)),
    });

    axios.get(route('api.properties.fetchLinksForPagination', id), {
        params: {
            _: params._,
        }
    }).then(({data: {currentNumber, total, urlNext, urlPrevious}}) => {
        if (currentNumber) {
            document.querySelectorAll('.currentNumber').forEach((el) => {
                el.textContent = currentNumber;
            })
        }

        if (urlNext) {
            document.querySelectorAll('.urlNext').forEach((el) => {
                el.setAttribute('href', urlNext);
            })
        }

        if (urlPrevious) {
            document.querySelectorAll('.urlPrevious').forEach((el) => {
                el.setAttribute('href', urlPrevious);
            })
        }

        if (parseInt(total) > 0) {
            document.querySelectorAll('.total').forEach((el) => {
                el.textContent = total;
            })

            document.querySelectorAll('[data-with-results]').forEach((el) => {
                el.classList.remove('d-none');
            });

            document.querySelector('[data-without-results]').classList.add('d-none');
        }
    });
}

function copyText() {
    let link = document.getElementById("copyLinkToClipboard")?.value;
    if (!link) return;
    console.log('current link', link)
    navigator.clipboard.writeText(link);
    toastSuccess('Link copiado')
}

/**
 * @param {HTMLImageElement} that
 */
function onErrorImage(that) {
    that.onerror = null;
    that.src = '/images/noLogo.svg';
    that.style.width = '400px';
    that.style.height = '400px';
}

window.onErrorImage = onErrorImage;

function listeningScroll() {
    const navbarTop = document.getElementById('navbar_top');
    if (!navbarTop) return;

    if (window.scrollY > 150) {
        navbarTop.classList.add('fixed-top');
        navbarTop.classList.add('d-block');
        navbarTop.classList.remove('d-none');

        // add padding top to show content behind navbar
        let navbarEl = document.querySelector('.navbar');
        if (!navbarEl) return;
        let navbar_height = navbarEl.offsetHeight;
        document.body.style.paddingTop = navbar_height + 'px';
    } else {
        navbarTop.classList.remove('fixed-top');
        navbarTop.classList.remove('d-block');
        navbarTop.classList.add('d-none');
        // remove padding top from body
        document.body.style.paddingTop = '0';
    }
}

function videoUrl() {
    //Set videoAnchor
    let url = window.location.href.split("#")[0];

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    let video = urlParams.get('video');

    if (!video) {
        var separator = url.includes('?') ? '&' : '?';
        window.history.pushState("", "", url + separator + 'video=true#video');
    }
}

function toggleExcluded(adId) {
    const userEl = document.querySelector('[name="data-user"]');
    if (!userEl) return;
    const user = JSON.parse(userEl.value);
    if (!user) {
        const myModal = new window.bootstrap.Modal(document.getElementById('model-exclude'), {})
        myModal.toggle();
        return
    }

    axios.post(route('api.marked-ads.toggle-property-excluded-by-auth', adId)).then(({data: {message}}) => {
        // const elSwal = document.querySelector('.swal2-icon.swal2-icon-show')
        Swal.fire({
            title: "Imóvel excluído",
            html: message,
            iconHtml: '<img class="" style="width: 30px" src="/images/trash_new.svg" alt="">',
            confirmButtonText: "Fechar",
            customClass: {
                icon: 'border-blue'
            }
        }).then(() => {
            document.querySelector(`[data-property-ad-id="${adId}"]`)?.remove()
        });
    })
}

function getIndex() {
    setTimeout(() => {
        let active = document.querySelector('.swiper-fullscreen .swiper-slide-active')
        let dataIndex = active?.getAttribute('data-swiper-slide-index')
        let index = parseInt(dataIndex || 0);
        const indexFoto = document.getElementById('index-foto');
        if (indexFoto) indexFoto.innerText = String(index + 1);
    }, 200)
}

// Function to update photo counter for any swiper instance
function updatePhotoCounter(swiperInstance) {
    const indexElement = document.getElementById('index-foto');
    if (indexElement && swiperInstance) {
        // Get real index (accounting for loop mode)
        const realIndex = swiperInstance.realIndex || 0;
        indexElement.innerText = String(realIndex + 1);
    }
}

const openFullScreen = () => {
    const swiperFullScreen = getSwiperFullScrren();

   /* getMainSwiper().then((mainSwiper) => {
        console.debug('current index on open', swiperFullScreen.activeIndex, mainSwiper.activeIndex);

        swiperFullScreen.slideTo(mainSwiper.activeIndex, 0)

        getIndex();
    });*/

    $('body').addClass('body-stuck');

    $('.fullscreen-wrapper').addClass('fullscreen-pop');

    $('.swiper-fullscreen')
        .addClass('d-block')
        .removeClass('d-none');

    $('.fullscreen-wrapper .targetfotos').addClass('btn-effect');

    $('.change-container')
        .removeClass('container')
        .addClass('container-fluid');

    $('.share')
        .addClass('d-none')
        .addClass('d-md-block');

    $('.fav')
        .addClass('d-none')
        .addClass('d-md-block');

    $('.wraper-fullscreen').addClass('d-flow-root');
}

const closeFullScreen = () => {
    console.debug('popoff');

    const swiperFullScreen = getSwiperFullScrren();

    /*getMainSwiper().then((mainSwiper) => {
        console.debug('current index on close', swiperFullScreen.activeIndex, mainSwiper.activeIndex);

        mainSwiper.slideTo(swiperFullScreen.activeIndex, 0);
    })
*/
    $('body').removeClass('body-stuck');

    $('.fullscreen-wrapper').removeClass('fullscreen-pop');
    $('.fullscreen-wrapper .targetfotos').removeClass('btn-effect');
    $('.fullscreen-wrapper .targetvideos').removeClass('btn-effect');

    $('.change-container')
        .removeClass('container-fluid')
        .addClass('container');

    $('.video').addClass('d-none').removeClass('d-block');

    $('.swiper-fullscreen').addClass('d-none').removeClass('d-block');

    $('.share').removeClass('d-none');

    $('.fav').removeClass('d-none');

    $('.wraper-fullscreen').removeClass('d-flow-root');
}

const observerForCLoseFullScreen = () => {
    document.querySelectorAll('[data-action="pop-of-fullscreen"]')
        .forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                closeFullScreen();
            });
        });

    document.addEventListener('keyup', (e) => {
        e.preventDefault();
        if (e.key === "Escape") {
            console.debug('Escape pressed');
            closeFullScreen();
        }
    });
}

setTimeout(() => {
    document.querySelector('[v-cloak]')?.removeAttribute('v-cloak')
}, 50)

$(document).ready(function () {
    $('.pop-fullscreen-video').click(function () {
        console.log('video');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        $('.fullscreen-wrapper .targetvideos').addClass('btn-effect');
        $('.video').addClass('d-block').removeClass('d-none');
    });

    $('.pop-fullscreen-video-3d').click(function () {
        console.log('video-3d');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        $('.fullscreen-wrapper .targetvideos-3d').addClass('btn-effect');
        $('.video-3d').addClass('d-block').removeClass('d-none');
    });

    $('.targetfotos').click(function () {
        $('.change-on-fullscreen-videos').removeClass('btn-effect');
        $('.targetfotos').addClass('btn-effect');
        $('.video').addClass('d-none').removeClass('d-block');
        $('.swiper-fullscreen').addClass('d-block').removeClass('d-none');

        $('.share').addClass('d-none');
        $('.fav').addClass('d-none');
    });

    $('.change-on-fullscreen-videos').click(function () {
        $('.change-on-fullscreen-videos').addClass('btn-effect');
        $('.targetfotos').removeClass('btn-effect');
        $('.swiper-fullscreen').addClass('d-none').removeClass('d-block');
        $('.video').addClass('d-block').removeClass('d-none');
    });

    //Check if url has video hash
    var hash = window.location?.hash;

    //Open video if hash is set
    if (hash === '#video') {
        //Open video
        console.debug('Video hash found');
        $('.pop-fullscreen-video').click();
    }

    var favLoading = false;

    var currentUrl = window.location.href;

    var missesUrl = route('myfavs');

    //Set timeout to affect vue elements
    setTimeout(function () {
        $(".property-ad-in-list").each(function () {
            if ($(this).find('#isfavorite').val() == 'FALSE') {
                $(this).find('#tiradaqui').addClass('hide');
                $(this).find('#favoritofalso').removeClass('hide');
            } else {
                $(this).find('#favoritofalso').addClass('hide');
                $(this).find('#tiradaqui').removeClass('hide');
            }
        });

        $('.effect-favorite').click(function () {
            if (favLoading == false) {

                favLoading = true;

                var wrapParent = $(this).closest('.property-ad-in-list');
                var propid = wrapParent.find('#target-prop-id').val();
                var uuu = wrapParent.find('#uuu').val();
                var isfavorite = wrapParent.find('#isfavorite').val();
                var type = wrapParent.find('#type').val();
                var targetAllAlike = $('.apropcookie-' + propid);

                $.get(route('setfav'), {
                    'ad_id': propid,
                    'user_id': uuu,
                    'is_fav': isfavorite,
                    'mark_type': type
                }, function (data) {
                    if (data != "Failed") {
                        wrapParent.find('#isfavorite').val(data);
                        if (wrapParent.find('#isfavorite').val() == 'FALSE') {

                            targetAllAlike.find('#tiradaqui').addClass('hide');
                            targetAllAlike.find('#favoritofalso').removeClass('hide');
                        } else {
                            setTimeout(function () {
                                $('#successFavsModal').modal('show');
                            }, 200);
                            setTimeout(function () {
                                $('#successFavsModal').modal('hide')
                            }, 3000);

                            targetAllAlike.find('#tiradaqui').removeClass('hide');
                            targetAllAlike.find('#favoritofalso').addClass('hide');

                            if (currentUrl == missesUrl) {
                                location.reload();
                            }
                        }
                    }

                    favLoading = false;
                });
            }
        });

        $('.remove').click(function () {

            if (favLoading == false) {

                favLoading = true;

                var wrapParent = $(this).closest('.property-ad-in-list');
                var propid = wrapParent.find('#target-prop-id').val();
                var uuu = wrapParent.find('#uuu').val();
                var isfavorite = wrapParent.find('#isfavorite').val();
                var type = wrapParent.find('#type').val();
                var targetAllAlike = $('.apropcookie-' + propid);

                $.get(route('setfav'), {
                    'ad_id': propid,
                    'user_id': uuu,
                    'is_fav': isfavorite,
                    'mark_type': type
                }, function (data) {

                    wrapParent.find('#isfavorite').val(data);

                    if (wrapParent.find('#isfavorite').val() == 'FALSE') {
                        Swal.fire({
                            title: "Imóvel removido da lista",
                            text: "O imóvel foi removido com sucesso da lista de favoritos!",
                            icon: "error",
                            confirmButtonText: "Fechar"
                        });
                        targetAllAlike.find('#tiradaqui').addClass('hide');
                        targetAllAlike.find('#favoritofalso').removeClass('hide');
                        if (currentUrl == missesUrl) {
                            location.reload();
                        }
                    } else {
                        targetAllAlike.find('#tiradaqui').removeClass('hide');
                        targetAllAlike.find('#favoritofalso').addClass('hide');
                    }

                    favLoading = false;
                });
            }
        });
    }, 1000);
});

document.addEventListener("DOMContentLoaded", function () {
    console.debug('DOM loaded');

    // Initialize Vue phone number components after DOM is ready
    const phoneNumberVue = document.querySelectorAll(".phoneNumberDivVue");
    Array.prototype.forEach.call(phoneNumberVue, (el) => new Vue({el}));

    document.querySelector('#video-url')?.addEventListener('click', videoUrl);

    document.querySelectorAll('[data-get-index]').forEach(el => {
        el.addEventListener('click', getIndex)
    })

    window.addEventListener('scroll', () => listeningScroll())

    document.querySelectorAll('[data-trigger="copy"]').forEach(el => {
        el.addEventListener('click', function () {
            let copyText = document.querySelector(el.getAttribute('data-target'))?.innerText;
            if (!copyText) return;

            navigator.clipboard.writeText(copyText).then(() => {
                el.classList.remove('fa-copy');
                el.classList.add('fa-check');
                setTimeout(() => {
                    el.classList.remove('fa-check');
                    el.classList.add('fa-copy');
                }, 1500);
            }).catch(() => {});
        });
    })

    setTimeout(() => {
        document.querySelectorAll('.pop-fullscreen-images').forEach(el => {
            el.addEventListener('click', (e) => {
                console.debug('pop-fullscreen-images');
                e.preventDefault();
                openFullScreen();
            });
        })
    }, 200);

    document.getElementById("copyLinkToClipboardDiv")?.addEventListener("click", copyText, false);

    let elPopUp = document.querySelector('#btn-open-full-screen');
    console.debug('elPopUp', elPopUp)
    elPopUp?.addEventListener('click', (e) => {
        console.debug('pop-fullscreen-images');
        e.preventDefault();
        openFullScreen();
    });

    observerForCLoseFullScreen();

    fetchLinksForPagination();
});

window.videoUrl = videoUrl;

window.toggleExcluded = toggleExcluded

window.getIndex = getIndex;

new Vue({
    el: '.withRecaptcha',
    name: 'FormRecaptcha',
    components: {
        FormContact
    },
    data() {
        return {
            endpoint: '',
        }
    },
    mounted() {
        const endpointElement = document.querySelector('#endpoint-vue');
        if (endpointElement) {
            this.endpoint = JSON.parse(endpointElement.value);
        } else {
            console.error("Element #endpoint-vue not found!");
        }
    }
})


const el = document.querySelector('#contact_visit_or_recomend')

if (el) {
    new Vue({
        el,
        data() {
            return {
                recomend: null,
                modalOpen: document.querySelector('#session-modal-open')?.value === 'true',
            }
        },
        mounted() {
            if (this.modalOpen) {
                console.log('abriu modal')
                setTimeout(function () {
                    $('#successModal').modal('show');
                }, 200);
                setTimeout(function () {
                    $('#successModal').modal('hide')
                }, 4000);
            }
        },
        methods: {
            legislationString(url) {
                return HelperJS.legislationForPhoneN(url)
            }
        }
    })
}
